// extracted by mini-css-extract-plugin
export default {"container":"hero_container__ALQhR","info":"hero_info__GFpVQ","lg":"hero_lg__5mKFS","heading":"hero_heading__L7O2I","infoContainer":"hero_infoContainer__mFtt7"};